import Vue from 'vue';

import contact from '../components/contact/Contact';
import dates from '../components/dates/Date';
import digit from '../components/digit/Number';
import file from '../components/file/File';
import money from '../components/money/Money';
import selector from '../components/selector/Selector';
import tables from '../components/table/Table';
import textArea from '../components/textarea/Textarea';
import tips from '../components/tips/Tips';
import version from '../components/version/Text';
import choose from '../components/choose/Choose';
import dateRange from '../components/dateRange/DateRange';
import formula from '../components/formula/Formula';
import location from '../components/location/Location';
import relatedApproval from '../components/relatedApproval/RelatedApproval';
import times from '../components/time/Time';
import all from '../components/all/all';
import list from '../components/List';

Vue.use(contact)
Vue.use(dates)
Vue.use(digit)
Vue.use(file)
Vue.use(money)
Vue.use(selector)
Vue.use(tables)
Vue.use(textArea)
Vue.use(tips)
Vue.use(version)
Vue.use(choose)
Vue.use(dateRange)
Vue.use(formula)
Vue.use(location)
Vue.use(relatedApproval)
Vue.use(times)
Vue.use(all)
Vue.use(list)
